module.exports = __webpack_public_path__ + "img/9.7b662d38.png";